export default __webpack_public_path__ + "static/media/moq-blue.d96b8303.gif";